export default __webpack_public_path__ + "static/media/instagram.461aba6d.svg";